export default __webpack_public_path__ + "static/media/german-marshall-fund-of-united-states.6e69967f.png";